export default {
  getLinkOfOnlineLecture: '/onlineLecture/getOnlineLecture',
  getRecordingOfAnOnlineLecture: '/onlineLecture/getRecordingOfAnOnlineLecture',
  getRedirectionUrl: '/onlineLectureStudent/getRedirectionUrl',
  getLectureMeetingId: '/onlineLectureStudent/getLectureMeetingId'
}
